/**
 * Platform-level events for shell and micro-frontend communication.
 * These events are used across the ABAX ecosystem, not specific to parcels.
 */

/** Detail payload for shell:locale-changed CustomEvent */
export interface LocaleChangedDetail {
  locale: string;
  isoLocale: string;
}

/** Typed CustomEvent for locale changes broadcast by the shell */
export class LocaleChangedEvent extends CustomEvent<LocaleChangedDetail> {
  static readonly eventType = 'shell:locale-changed';

  constructor(detail: LocaleChangedDetail) {
    super(LocaleChangedEvent.eventType, { detail });
  }
}

// Cross-MFE event bus — typed singleton using mitt
export { getSharedEventBus, useSharedEvent } from './shared-event-bus';
